import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { FC } from 'react';

interface EmojiSelectorProps {
	command: (...args: any[]) => void;
}

export const EmojiSelector: FC<EmojiSelectorProps> = ({ command }) => {
	const handleSelect = ({ native }: any) => {
		command({ id: native });
	};

	return <Picker autoFocus data={data} onEmojiSelect={handleSelect} />;
};
